export enum LogCategoryTypes {
  Debug = 'debug',
  Reservation = 'reservation',
  CardSync = 'card-sync',
  Exception = 'exception',
}
